export enum SettingsTab {
    SiteSetting = 'Site Setting',
    Domains = 'Domains',
    PlanCredits = 'Plan & Credits',
    Account = 'Account',
    Notification = 'Notification',
    Usage = 'Usage',
    WegicCloud = 'Wegic Cloud',
    Memory = 'Memory',
    HelpCenter = 'Help Center',
    ContactUs = 'Contact Us',
}

export enum SettingsModalSource {
    AccountMenuSettings = 'account_menu_settings',
    AccountMenuUsage = 'account_menu_usage',
    CloudUsage = 'cloud_usage',
    CreditCare = 'credit_care',
    CreditsCardUsage = 'credits_card_usage',
    CreditsModalUsageButton = 'credits_modal_usage_button',
    CreditsModalUsageLink = 'credits_modal_usage_link',
    NotificationCreditsUsage = 'notification_credits_usage',
    ProjectMemoryCard = 'project_memory_card',
    UserMenuSettings = 'user_menu_settings',
    WorkspaceProjectMenu = 'workspace_project_menu',
}

export type SettingsModalType = 'global' | 'project';

interface StoreSettingsModalState {
    visible: boolean;
    activeTab: SettingsTab;
    type: SettingsModalType;
    source: SettingsModalSource | null;
}

interface StoreSettingsModal extends StoreSettingsModalState {
    setActiveTab: (tab: SettingsTab) => void;
    setVisible: (visible: boolean) => void;
    reset: () => void;
};

export type {
    StoreSettingsModal,
    StoreSettingsModalState,
};
